// FEATURED COLLECTION (namespace .s-featured)
// - Quick add com fetch
// - Abertura instantânea do cart drawer (Halo)
// - Proteção contra duplicação (LOCK GLOBAL)

(function () {

  // 🔒 LOCK GLOBAL — impede add duplicado por race condition
  if (window.__FEATURED_QUICK_ADD_LOADED__) return;
  window.__FEATURED_QUICK_ADD_LOADED__ = true;

  window.__FEATURED_ADD_IN_PROGRESS__ = false;

  function openCartDrawer() {
    var openBtn =
      document.querySelector('[data-open-cart-sidebar]') ||
      document.querySelector('[data-cart-toggle]');

    if (openBtn) {
      openBtn.click();
      return;
    }

    // Fallback mínimo
    document.body.classList.add('open-cart-sidebar');
  }

  function initQuickAdd(section) {
    var forms = section.querySelectorAll('.s-featured__quick-add-form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      var submitButton = form.querySelector('[data-quick-add-button]');
      if (!submitButton) return;

      // Impede propagação para links do card
      form.addEventListener('click', function (e) {
        e.stopPropagation();
      });

      // Abertura ultra-rápida no toque
      submitButton.addEventListener(
        'pointerdown',
        function () {
          openCartDrawer();
        },
        { once: true }
      );

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();

        // 🔒 LOCK — se já estiver adicionando, aborta
        if (window.__FEATURED_ADD_IN_PROGRESS__) {
          console.warn('[FEATURED] Add já em progresso, ignorado');
          return;
        }

        window.__FEATURED_ADD_IN_PROGRESS__ = true;

        if (!window.fetch) {
          window.__FEATURED_ADD_IN_PROGRESS__ = false;
          return;
        }

        var formData = new FormData(form);
        var variantId = formData.get('id');

        if (!variantId) {
          console.error('[FEATURED] Variant ID inválido');
          window.__FEATURED_ADD_IN_PROGRESS__ = false;
          return;
        }

        submitButton.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function () {
            // Atualiza o cart se o tema expuser API
            if (typeof Shopify !== 'undefined' && Shopify.getCart) {
              Shopify.getCart(function (cart) {
                if (typeof window.updateCart === 'function') {
                  window.updateCart(cart);
                }
              });
            }
          })
          .catch(function (err) {
            console.error('[FEATURED] Erro no quick add:', err);
          })
          .finally(function () {
            submitButton.classList.remove('is-loading');
            window.__FEATURED_ADD_IN_PROGRESS__ = false;

          }, 150);
      });
    });
  }

  function initReveal(section) {
    if (!section.classList.contains('s-featured--reveal')) return;

    if (!('IntersectionObserver' in window)) {
      section.querySelectorAll('.s-featured__card').forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    section.querySelectorAll('.s-featured__card').forEach(function (card) {
      observer.observe(card);
    });
  }

  // ==============================
  // CARROSSEL DESKTOP – NAVEGAÇÃO
  // ==============================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.s-featured__nav-btn');
    if (!btn) return;

    var section = btn.closest('.s-featured');
    if (!section) return;

    var list = section.querySelector('.s-featured__list');
    var card = list && list.querySelector('.s-featured__card');
    if (!list || !card) return;

    var styles = window.getComputedStyle(list);
    var gap = parseInt(styles.columnGap || styles.gap || 0, 10);

    var scrollAmount = card.offsetWidth + gap;

    list.scrollBy({
      left: btn.classList.contains('is-next') ? scrollAmount : -scrollAmount,
      behavior: 'smooth',
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.s-featured').forEach(function (section) {
      initQuickAdd(section);
      initReveal(section);
      initCarouselNav(section); // 🔥 FALTAVA ISSO
    });
  });
})();


